'use strict';

var mediator = require('../mediator'),
  ModalView = require('../components/ModalView'),
  errorModalTemplate = require('../../tmpl/client/modal/errorModal.hbs'),
  events = require('../config').events,
  ErrorModalView;

ErrorModalView = ModalView.extend({
  template: errorModalTemplate,

  initialize: function() {
    ErrorModalView.__super__.initialize.apply(this, arguments);
    mediator.on(events.error.generic, this.open);
  },

  onOpen() {
    this.$('#errorModel').parent().parent().attr('role', 'alertdialog');
    this.$('#errorModel').css('display', 'block');
    if (!this.$('#errorModelCloseBtn').attr('event')) {
      this.$('#errorModelCloseBtn').on('keydown', (e) => {
        if (e.key === 'Tab') {
          e.preventDefault();
        }
      });
      this.$('#errorModelCloseBtn').attr('event', 1);
    }

    this.$lastActiveElement = this.$(document.activeElement);
    const focusFun = () => {
      if (this.modal.getState() === 'opened') {
        this.$('#errorModel').focus();
      } else {
        setTimeout(focusFun, 300);
      }
    }
    setTimeout(focusFun, 300);
  },

  onClose() {
    if (this.$lastActiveElement) {
      this.$lastActiveElement.focus();
      this.$lastActiveElement = null;
    }
    this.$('#errorModel').css('display:none');
    this.$('#errorModel').parent().parent().removeAttr('role', 'alertdialog');
  }
});

// Create global error modal view
module.exports = new ErrorModalView();



// WEBPACK FOOTER //
// ./assets/js/components/ErrorModalView.js